import { QqModel } from "../../model/qq.model";
import { DROPDOWN_CHANGED_ACTION, QqActionType } from "../qq-action.type";

export const dropdownAction: (qq: QqModel, selection: string) => QqActionType =
  (qq, selection) => {
    return {
      type: DROPDOWN_CHANGED_ACTION,
      data: {
        qq,
        selection,
      },
    };
  };
